export const environment = {
  isProduction: false,
  apiUrl: 'https://api-hml.lawservices.com.br/api'

};
